import React, { useState } from "react";
import './BathroomCleaningInfo.css'; // Import the updated CSS file
import ThumbImg from '../../Images/Serviceimg/thumbs-up.png';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore'; // Import the expand icon
import RemoveImg from '../../Images/Serviceimg/remove.png'
const BathroomCleaningInfo = () => {
    const [activeIndex, setActiveIndex] = useState(null); // State to manage the active question

    const handleToggle = (index) => {
        // Toggle the active index on click
        setActiveIndex(activeIndex === index ? null : index);
    };

    return (
        <div className="cleaning-card">
            {/* <div style={{ textAlign: 'start', fontSize: '1.5rem', fontWeight: '600', color: '#002654' }}>About Bathroom Cleaning</div> */}
            <div className="section-heading">Included</div>
            <ul className="service-list">
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Dusting & Dry Vacuuming - Removal of dust, dirt, and debris
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Scrubbing of Tiles & Grout - Deep cleaning and scrubbing
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Disinfection of Faucets & Fittings - Elimination of germs
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Cleaning of Mirrors & Glass Surfaces - Spotless finish
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Toilet & Sink Cleaning - Disinfecting sanitary fixtures
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Floor Cleaning - Mopping with disinfectant
                </li>
                <li className="service-item">
                    <span className="thumb-icon"><img src={ThumbImg} alt="" /></span>
                    Drying - Allow surfaces to dry for 1-2 hours
                </li>
            </ul>

            <div className="section-heading">Excluded</div>
            <ul className="service-list">
                <li className="service-item">
                    <span className="thumb-icon"><img src={RemoveImg} alt="" /></span>
                    Complete Removal of Deep Mold Stains
                </li>
            </ul>

            <div className="section-heading">Frequently Asked Questions</div>

            {[
                { question: "Is this service applicable for all types of bathrooms?", answer: "Yes, this service can be performed in all kinds of bathrooms, whether tiled or not." },
                { question: "Will this service damage my bathroom fittings?", answer: "No, our professionals are trained to handle all bathroom fittings with care and use gentle, effective cleaning products." },
                { question: "Is there anything I need to do after the service?", answer: "You just need to allow the bathroom surfaces to dry properly before use." },
                { question: "What happens if there’s no water or electricity during the service?", answer: "In such cases, the customer can reschedule the service with the help of Astra Clean customer care." },
                { question: "Will the service remove stubborn stains?", answer: "Stubborn stains like hard water stains might require special treatments, which may not be included in the basic package." },
            ].map((faq, index) => (
                <div className="faq-accordion" key={index}>
                    <div className="faq-question" >
                        <div>{faq.question}</div>
                        <ExpandMoreIcon className={`faq-arrow ${activeIndex === index ? "rotate" : ""}`} onClick={() => handleToggle(index)} />
                    </div>
                    {activeIndex === index && (
                        <div className="faq-answer">
                            <div>{faq.answer}</div>
                        </div>
                    )}
                </div>
            ))}
        </div>
    );
};

export default BathroomCleaningInfo;
